// extracted by mini-css-extract-plugin
export default {"layout":"_1e1a568beb f0f70aced1 _1f9980a98d","h_slide":"f127b3881c","category":"_39594e8c72 _6d479a225b eb420bdf60"};